//import {caseInsensitiveSort} from "../common/Utils";

export const achFilesJobColumns = (handleDownlodLinkClick)=>[
    {
		name: 'Job Id',
		cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.jobId}</div>,
		align: "center",
	},
	{
		name: 'Job Run Date',
		cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.jobRunDate}</div>,
		align: "center",
	},	
	{
		name: 'Job Run Type',
		cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.jobRunType}</div>,
		align: "center",
	},
	{
		name: 'Job Status',
		cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.jobStatus}</div>,
		align: "center",
	},
	{
		name: 'Job Run By',
		cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.jobRunBy}</div>,
		align: "center",
	},
	{
		name: 'ACH File Name',
		field:'action',	
		align:"center",
		//cell: row => <div style={{align:"center", textAlign:"center", alignContent:"center"}}>{row.achFileName? row.achFileName :""}</div>,
		 cell : (row) =>  (
		 	<div style={{align:"center", textAlign:"center", alignContent:"center"}}>
		 		{ row.achFileName? <a href="#" onClick={()=>handleDownlodLinkClick(row)}>{row.achFileName}</a> :""}</div>)
	}
];



